import { useEffect, useRef } from "react";

import { SWEvents } from "@constants/SWEvents";

type NewVersionCallback = () => void;

const PING_INTERVAL = 20 * 1000; // 20 seconds

export const useVersionCheckListener = (onNewVersion: NewVersionCallback): void => {
  const intervalId = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    const handleNewVersionModal = (event: MessageEvent): void => {
      if (event.data?.type === SWEvents.NEW_VERSION_AVAILABLE) {
        onNewVersion();
      }
    };

    if ("serviceWorker" in navigator) {
      // Add message event listener
      navigator.serviceWorker.addEventListener("message", handleNewVersionModal);

      // Set up interval to ping service worker
      intervalId.current = setInterval(() => {
        if (navigator.serviceWorker.controller) {
          navigator.serviceWorker.controller.postMessage({ type: SWEvents.CHECK_VERSION });
        }
      }, PING_INTERVAL);
    }

    return () => {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.removeEventListener("message", handleNewVersionModal);
      }
      if (intervalId.current) {
        clearInterval(intervalId.current);
      }
    };
  }, [onNewVersion]);
};

export default useVersionCheckListener;
